import { useEffect, useState } from "react";

export default function DateTimeBadge({ show }) {
  const [now, setNow] = useState(new Date());
  useEffect(() => {
    const i = setInterval(() => setNow(new Date()), 1000);
    return () => clearInterval(i);
  }, []);
  if (!show) return null;
  const d = now.toLocaleDateString("de-DE", { day: "2-digit", month: "2-digit", year: "numeric" });
  const t = now.toLocaleTimeString("de-DE", { hour: "2-digit", minute: "2-digit" });
  return (
    <div className="text-right shrink-0" data-testid="display-datetime">
      <div className="font-mono-num font-bold text-5xl text-[#00F0FF] leading-none">{t}</div>
      <div className="font-display uppercase tracking-widest text-xl text-[#8A99AD] mt-1">{d}</div>
    </div>
  );
}
